import {
    Datagrid,
    EditButton,
    Filter,
    List,
    SelectInput,
    TextField,
    TextInput,
    TopToolbar,
    useGetList,
    useListContext,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ThumbnailField from '../../common/ThumbnailField';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import PdfViewer from '../../common/PdfViewer';
import useIsPermission from '../../hooks/useIsPermission';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

export const PdfCategoryFilterInput = (props: any) => {
    const { data, isLoading } = useGetList('pdf-categories', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'name', order: 'ASC' },
    });

    if (isLoading) return null;

    const choices = data?.map(item => ({ id: item.id, name: item.name })) || [];

    return (
        <SelectInput
            {...props}
            label="PDF Categories"
            source="categoryId"
            choices={choices}
            alwaysOn
            fullWidth
        />
    );
};

const PdfFilter = (props: any) => {
    return (
        <Filter {...props}>
            <PdfCategoryFilterInput alwaysOn {...props} />
            <TextInput
                variant={'outlined'}
                label="Title"
                source="title"
                alwaysOn={true}
                defaultValue=""
            />
        </Filter>
    );
};

const ListActions = () => {
    const { filterValues } = useListContext();
    const query = new URLSearchParams(filterValues).toString();

    return (
        <TopToolbar>
            <Link to={`/pdfs/create?${query}`} style={{ textDecoration: 'none' }}>
                <Button
                    variant="text"
                    startIcon={<Add />}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'rgba(0, 0, 0, 0.87)',
                        border: 'none',
                        backgroundColor: 'transparent',
                        padding: '8px 16px',
                        fontSize: '14px',
                    }}
                >
                    <Typography variant="button">Create</Typography>
                </Button>
            </Link>
        </TopToolbar>
    );
};

const PdfsList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission('PDF');

    return (
        <div>
            <List
                actions={isWritable && <ListActions />}
                sort={{ field: 'createdAt', order: 'DESC' }}
                filters={<PdfFilter />}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source={'title'} />
                    <ThumbnailField source="thumbnail" />
                    <PdfViewer source="url" />
                    <TextField source={'isDownloadable'} />
                    <FormattedDateTimeField source="createdAt" />
                    {isUpdatable && <EditButton />}
                    {isDeletable && <ConfirmDeleteButton />}
                </Datagrid>
            </List>
        </div>
    );
};

export default PdfsList;
